import React, { FC } from 'react';
import { Backdrop, Grid } from '@material-ui/core';
import { useStyles } from './style';
import { SpinnerIcon } from '../CustomIcons';

interface Props {
  isLoading: boolean;
}

export const SpinnerWithProps: FC<Props> = ({ isLoading }) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={isLoading}>
      <Grid container direction="column" alignItems="center">
        <SpinnerIcon className={classes.rotateIcon} />
      </Grid>
    </Backdrop>
  );
};
